import { httpClient } from '@/services/http/httpClient'

type ApproveIdeaParams = {
  ideaId: string
  description: string
}

export async function approveIdea({ ideaId, description }: ApproveIdeaParams) {
  const { data } = await httpClient.post(
    `/ideas/funnel/direct-approvals/${ideaId}/approve`,
    {
      description,
    },
  )

  return data
}
